export default class {
  constructor () {
    if (typeof window.Livewire === 'undefined') {
      throw 'window.Livewire is undefined. Make sure to include @livewireScripts before this script';
    }

    this.livewireComponents = [];
  }

  cacheLivewireComponents() {
    // Save Livewire components to refresh later
    this.livewireComponents[window.location.pathname] = document.querySelectorAll(
      '[wire\\:id]'
    );

    // alert('cacheLivewireComponents')
  }

  refreshLivewireComponents() {
    // Refresh any previously saved Livewire Components
    if (this.livewireComponents[window.location.pathname]) {
      this.livewireComponents[window.location.pathname].forEach(function(el) {
        const component = el.__livewire;
        const dataObject = {
          fingerprint: component.fingerprint,
          serverMemo: component.serverMemo,
          effects: component.effects
        };
        el.setAttribute('wire:initial-data', JSON.stringify(dataObject));
      });
    }

    // Always restart Livewire
    window.Livewire.restart()
    
    // alert('refreshLivewireComponents')

  }

}
